/* eslint-disable react/prop-types */
import React from 'react';
var RemoveIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c, _d = _a.strokeWidth, strokeWidth = _d === void 0 ? 2 : _d, _e = _a.styles, styles = _e === void 0 ? {} : _e, viewBox = _a.viewBox;
    return (React.createElement("svg", { viewBox: "0 0 ".concat(size, " ").concat(size), height: size, width: size, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("g", { transform: "matrix(1,0,0,1,0,0)" },
            React.createElement("path", { d: "M4.5 19.5L19.5 4.5", fill: "none", stroke: color, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: strokeWidth }),
            React.createElement("path", { d: "M4.5 4.5L19.5 19.5", fill: "none", stroke: color, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: strokeWidth }))));
};
export default RemoveIcon;
